export const APP_CONFIG = {
  API: 'https://medystacja-backend.herokuapp.com',
  // API: 'http://localhost:4000',
}
